import { Fragment } from 'react'
import Box from '../../../Global/Box'

export const showTransformItem = (item) => {
  const { layout } = item

  if (layout === 'spacer') {
    const { height } = item
    return (
      <>
        <div
          className="d-flex align-content-center justify-content-center mb-2"
          style={{ fontSize: 11, gap: 7 }}
        >
          <div>
            <b>layout:</b> {layout}
          </div>
          {height && (
            <div>
              <b>height:</b> {height}
            </div>
          )}
        </div>

        <div
          className="bg-light align-content-center rounded"
          style={{ height }}
        >
          Espacio
        </div>
      </>
    )
  }

  if (layout === 'html_content') {
    const { htmlContent } = item
    return (
      <>
        <div
          className="d-flex align-content-center justify-content-center mb-2"
          style={{ fontSize: 11, gap: 7 }}
        >
          <div>
            <b>layout:</b> {layout}
          </div>
          {htmlContent && (
            <div>
              <b>Content:</b>{' '}
              {htmlContent.length > 100
                ? `${htmlContent.substring(0, 100)}...`
                : htmlContent}
            </div>
          )}
        </div>

        <div
          className="bg-light align-content-center rounded"
          // style={{ height }}
        >
          Contenido HTML
        </div>
      </>
    )
  }

  if (layout === 'banner_image_single') {
    const { height } = item
    return (
      <>
        <div
          className="d-flex align-content-center justify-content-center mb-2"
          style={{ fontSize: 11, gap: 7 }}
        >
          <div>
            <b>layout:</b> {layout}
          </div>
          {height && (
            <div>
              <b>height:</b> {height}
            </div>
          )}
        </div>

        <div
          className="bg-light align-content-center rounded"
          style={{ height }}
        >
          <i className="fas fa-images mr-1" />
          Espacio de imagen
        </div>
      </>
    )
  }

  if (layout === 'banner_image_carousel') {
    const { height } = item
    return (
      <>
        <div
          className="d-flex align-content-center justify-content-center mb-2"
          style={{ fontSize: 11, gap: 7 }}
        >
          <div>
            <b>layout:</b> {layout}
          </div>
          {height && (
            <div>
              <b>height:</b> {height}
            </div>
          )}
        </div>

        <div
          className="bg-light align-content-center rounded"
          style={{ height }}
        >
          <i className="fas fa-images mr-1" />
          Espacio de imagen
        </div>
      </>
    )
  }

  if (layout === 'header_text') {
    const { height, fontSize, text } = item
    return (
      <>
        <div
          className="d-flex align-content-center justify-content-center mb-2"
          style={{ fontSize: 11, gap: 7 }}
        >
          <div>
            <b>layout:</b> {layout}
          </div>
          {height && (
            <div>
              <b>height:</b> {height}
            </div>
          )}
          {fontSize && (
            <div>
              <b>fontSize:</b> {fontSize}
            </div>
          )}
        </div>

        <div
          className="bg-light align-content-center rounded"
          style={{ height }}
        >
          <i className="fas fa-heading mr-1" />
          {text?.es ?? text?.en}
        </div>
      </>
    )
  }

  if (layout === 'buttons_box') {
    return (
      <Box
        clasCard="card my-1 rounded"
        classNameHeader="card-header py-1"
        contentHeader={<h3 className="card-title pl-3 mt-0">{item.layout}</h3>}
        //contentHeader={<h3 className="card-title pl-3">{item.layout}</h3>}
        content={
          <div
            className="d-flex flex-wrap justify-content-center"
            style={{ gap: 10 }}
          >
            {item.items.map((itemSub1, indexSub1) => {
              return (
                <Fragment key={indexSub1}>
                  {showTransformItem(itemSub1)}
                </Fragment>
              )
            })}
          </div>
        }
      />
    )
  }

  if (layout === 'button') {
    const { text } = item
    return (
      <div className="btn btn-secondary rounded flex-fill">
        {text.es ?? text.en}
      </div>
    )
  }
}
